/**
 * Forum Moderation Service
 * 
 * API client for forum moderation actions (staff only)
 */

import { apiClient } from '../api/client'

export const forumModService = {
  /**
   * Lock a topic (prevent new replies)
   */
  async lockTopic(storeId: string, topicId: string) {
    return apiClient.put<{
      success: boolean
      message: string
      topic: { id: string; title: string; isLocked: boolean }
    }>(`/stores/${storeId}/forum/topics/${topicId}/lock`, {})
  },

  /**
   * Unlock a topic (allow new replies)
   */
  async unlockTopic(storeId: string, topicId: string) {
    return apiClient.put<{
      success: boolean
      message: string
      topic: { id: string; title: string; isLocked: boolean }
    }>(`/stores/${storeId}/forum/topics/${topicId}/unlock`, {})
  },

  /**
   * Pin a topic (show at top of list)
   */
  async pinTopic(storeId: string, topicId: string) {
    return apiClient.put<{
      success: boolean
      message: string
      topic: { id: string; title: string; isPinned: boolean }
    }>(`/stores/${storeId}/forum/topics/${topicId}/pin`, {})
  },

  /**
   * Unpin a topic
   */
  async unpinTopic(storeId: string, topicId: string) {
    return apiClient.put<{
      success: boolean
      message: string
      topic: { id: string; title: string; isPinned: boolean }
    }>(`/stores/${storeId}/forum/topics/${topicId}/unpin`, {})
  },

  /**
   * Move topic to another board
   */
  async moveTopic(storeId: string, topicId: string, targetBoardId: string) {
    return apiClient.put<{
      success: boolean
      message: string
      topic: { 
        id: string
        title: string
        slug: string
        boardId: string
        boardSlug: string
        categorySlug: string
      }
    }>(`/stores/${storeId}/forum/topics/${topicId}/move`, { targetBoardId })
  },

  /**
   * Delete a topic permanently
   */
  async deleteTopic(storeId: string, topicId: string) {
    return apiClient.delete<{
      success: boolean
      message: string
      deletedPostsCount: number
    }>(`/stores/${storeId}/forum/topics/${topicId}`)
  },

  /**
   * Edit a post (moderator can edit any post)
   */
  async updatePost(storeId: string, postId: string, content: string) {
    return apiClient.put<{
      success: boolean
      message: string
      post: { id: string; content: string; updatedAt: string }
    }>(`/stores/${storeId}/forum/posts/${postId}`, { content })
  },

  /**
   * Delete a post permanently
   */
  async deletePost(storeId: string, postId: string) {
    return apiClient.delete<{
      success: boolean
      message: string
    }>(`/stores/${storeId}/forum/posts/${postId}`)
  },
}

export default forumModService
